import { Home, Settings } from "lucide-react";
import { NavLink } from "./NavLink";

// <md mobile drawer. Mirrors the desktop nav links — Operations expands inline
// as a labeled section rather than a dropdown since the dropdown wouldn't have
// room to open in the narrow viewport.
export function MobileNav({
  pathname,
  isAdmin,
  showOperations,
  onClose,
}: {
  pathname: string;
  isAdmin: boolean;
  showOperations: boolean;
  onClose: () => void;
}) {
  return (
    <nav
      id="mobile-nav"
      className="absolute inset-x-0 top-14 z-40 flex flex-col gap-1 border-primary-foreground/10 border-t bg-primary p-3 shadow-lg md:hidden"
    >
      <NavLink to="/home" isActive={pathname === "/home"} onClick={onClose}>
        <Home className="size-4" />
        Home
      </NavLink>
      {isAdmin && (
        <NavLink to="/config" isActive={pathname.startsWith("/config")} onClick={onClose}>
          <Settings className="size-4" />
          Configuration
        </NavLink>
      )}
      {showOperations && (
        <>
          <div className="px-3 pt-2 font-medium text-primary-foreground/60 text-xs uppercase tracking-wider">
            Operations
          </div>
          <NavLink to="/teams" isActive={pathname === "/teams"} onClick={onClose}>
            Claim Teams
          </NavLink>
          <NavLink to="/teams/history" isActive={pathname === "/teams/history"} onClick={onClose}>
            Team History
          </NavLink>
          <NavLink to="/teams/help" isActive={pathname === "/teams/help"} onClick={onClose}>
            Team Help
          </NavLink>
        </>
      )}
    </nav>
  );
}
